import React, {useEffect, useState} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import {url} from "../utils/UrlsUtil.ts";
import GiftCategorySwiper from "../components/swiper/GiftCategorySwiper.tsx";
import {post} from "../utils/FetchUtil.ts";
import FormatGoodsSwiper from "../components/swiper/FormatGoodsSwiper.tsx";
import MessageSamplesSwiper from "../components/swiper/MessageSamplesSwiper.tsx";
import {popErrors} from "../utils/MessageUtil.ts";
import "../../style/modal/online_msg_template_modal.scss";

interface OnlineMsgTemplateModalProps{
    categoryList: GiftCategoryDto[];
    show: boolean;
    handleClose: () => void;
    handleSubmit: (goodsDto: FormatGoodsDto | null, sampleMsgDto: SampleMessageDto | null) => void
}

const OnlineMsgTemplateModal:React.FC<OnlineMsgTemplateModalProps> = (
    {
        categoryList = [],
        show = false,
        handleClose = () => {},
        handleSubmit = () => {}
    }
) => {
    useEffect(() => {
        if(!show){
            setSelectedMsgSample(null);
            setSelectedFormatGoods(null);
        }
    }, [show]);
    const [selectedCategory, setSelectedCategory] = useState<GiftCategoryDto>({
        code: "",
        name: "すべて"
    });
    useEffect(() => {
        post<GiftCategoryDto>({
            action: "/api/template/online_msg/input_templates",
            data: selectedCategory
        })
            .then((data) => {
                if(data){
                    if(data.format_goods_list){
                        setFormatGoodsList(data.format_goods_list);
                    }else{
                        setFormatGoodsList([]);
                    }
                    if(data.sample_message_list){
                        setMsgSampleList(data.sample_message_list);
                    }else{
                        setMsgSampleList([]);
                    }
                }else {
                    setFormatGoodsList([]);
                    setMsgSampleList([]);
                }
            })
            .catch((reason) => {
                console.log(reason);
                setFormatGoodsList([]);
                setMsgSampleList([]);
            })
            .finally(() => {});
    }, [selectedCategory]);
    const [formatGoodsList, setFormatGoodsList] = useState<FormatGoodsDto[]>([]);
    const [selectedFormatGoods, setSelectedFormatGoods] = useState<FormatGoodsDto | null>(null);
    const [msgSampleList, setMsgSampleList] = useState<SampleMessageDto[]>([]);
    const [selectedMsgSample, setSelectedMsgSample] = useState<SampleMessageDto | null>(null);
    const handleSelectedCategory = (selectedDto: GiftCategoryDto) => {
        setSelectedCategory(selectedDto);
    }

    const onClickUseHandler = () => {
        if(selectedFormatGoods === null && selectedMsgSample === null){
            popErrors("テンプレートをご選択ください。");
        }else{
            handleSubmit(selectedFormatGoods, selectedMsgSample);
        }
    }

    return (
        <Modal id="modalOnlineMsgSamples" centered
               className="online-msg-samples-modal"
               show={show}
               onHide={handleClose}
        >
            <ModalHeader closeButton>
                <ModalTitle>
                    <img src={url("/images/logo/geeva_logo.png")} alt="geeva"/>
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <h3>テンプレートの利用</h3>
                <GiftCategorySwiper categoryList={categoryList}
                                    appendClass={"sample-category-swiper"}
                                    handleSelected={handleSelectedCategory}
                />
                {formatGoodsList && formatGoodsList.length !== 0 && (
                    <div className="samples-selection-area">
                        <h4>画像テンプレートから選ぶ</h4>
                        <FormatGoodsSwiper goodsList={formatGoodsList}
                                           appendClass={"picture-sample-swiper"}
                                           handleSelected={(dto) => {setSelectedFormatGoods(dto)}}
                        />
                    </div>
                )}
                {msgSampleList && msgSampleList.length !== 0 && (
                    <div className="samples-selection-area">
                        <h4>メッセージテンプレートから選ぶ</h4>
                        <MessageSamplesSwiper sampleList={msgSampleList}
                                              showName={true}
                                              appendClass={"message-sample-swiper"}
                                              handleSelected={(dto) => {setSelectedMsgSample(dto)}}
                        />
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={handleClose}>閉じる</Button>
                <Button variant="primary" onClick={onClickUseHandler}>利用する</Button>
            </ModalFooter>
        </Modal>
    );
};
export default OnlineMsgTemplateModal;